<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card>

            <v-alert width="100%" class="pr-2 pl-2" v-if="saveErrorMessage" type="error"> {{ saveErrorMessage }}</v-alert>

            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                          :search="search"
                          item-key="id"
                          :loading="isLoading"
                          :items-per-page="15">
                <template v-slot:[`item.programName`]="{ item }">
                    {{item.programName}}

                </template>

                <template v-slot:[`item.programId`]="{ item }">
                    {{item.programId}}

                </template>

                <template v-slot:[`item.isManual`]="{ item }">
                    <font-awesome-icon v-if="item.isManual !== null"
                                       :icon="item.isManual ? 'check' : 'times'"
                                       :color="item.isManual ? 'green' : 'red'" />

                </template>


                <template v-slot:top>
                    <v-toolbar flat>
                        <v-text-field v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            class="ml-1"
                            single-line
                            hide-details
                            clearable
                        />
                        <v-btn class="text-xs ml-2" v-on:click="refresh" color="primary">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog"
                                  max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary"
                                       dark
                                       class="mb-2"
                                       v-bind="attrs"
                                       v-on:click="initializeItem">
                                    Add
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form v-model="isValid">
                                            <v-row>
                                                <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.programName" label="Program Name*" :disabled="!editedItem.canDelete"
                                                                  :rules="[(v) => !!v || 'Required',(v) =>v.length <= 120 || 'Limited to 120 chars.',(v) => v.trim().length>1 || 'Required',]" />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.programId" label="Id*" :disabled="!editedItem.canDelete"
                                                                  :rules="[(v) => !!v || 'Required',(v) =>v.length <= 4 || 'Limited to 4 chars.',(v) =>!v.includes(' ') || 'Remove spaces.',]" />
                                                </v-col>
                                                <v-col>
                                                    <v-checkbox v-model="checked" dense label="Is Manual" :disabled="true"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!isValid"
                                           @click="save">
                                        Add/Update
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <span v-if="item.canDelete">
                        <v-icon small v-if="item.canDelete"
                                class="mr-2"
                                @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon small v-if="item.canDelete"
                                @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </span>
                    <span v-else>
                        --
                    </span>
                </template>

            </v-data-table>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { ProgramLookupInfo } from "@/types/admin/Lookup";

export default Vue.extend({
    name: "CertProgramMaintenance",
    data: function () {
        return {
            tab: null,
            luItems: [] as ProgramLookupInfo[],
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: "Program", align: "left", value: "programName" },
                { text: "Program ID", align: "left", value: "programId" },
                { text: "Is Manual", align: "left", value: "isManual" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: -1,
                isManual: true,
                canDelete: true,
                programId: "",
                programName: "",

            },
            defaultItem: {
                id: -1,
                isManual: true,
                canDelete: true,
                programId: "",
                programName: "",
            },
            errorMessage: "",
            isValid: true,
            search: "",
            isLoading: false,
            selectedProgramId: "",
            checked: true,
            saveErrorMessage: "",

        };
    },
    created: function () {
        this.reloadItems();
    },
    methods: {
        refresh: function () {
            this.reloadItems();
            this.errorMessage = "";
            this.saveErrorMessage = "";
        },
        reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getCertProgramList().then((res: any) => {
                this.luItems = res;
                this.$data.isLoading = false;

            });
            this.$data.isLoading = false;
        },
        initializeItem() {
            this.selectedProgramId = "";
            this.editedItem.isManual = true;
            this.dialog = true;

        },

        editItem(item: ProgramLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item);
            this.selectedProgramId = this.editedItem.programId;
            this.dialog = true;
        },

        deleteItem(item: ProgramLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.errorMessage = "";
            this.saveErrorMessage = "";
            if (!this.editedItem.canDelete) {
                this.closeDelete();
            }
            lookupsService.deleteCertProgram(this.editedItem.id).then((res) => {
                if (res.success == false) {
                    this.saveErrorMessage = res.messages.join(', ')
                }
                else {

                    this.luItems.splice(this.editedIndex, 1);
                }

                this.reloadItems(); //in case something was changed after that pull

            }).catch((e: any) => {
                this.saveErrorMessage = "Program is in use. Unable to Delete.";
                return;
            });


            this.closeDelete();

        },

        close() {
            this.errorMessage = "";
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.errorMessage = "";
            this.saveErrorMessage = "";
            this.editedItem.programName = this.editedItem.programName.trim();
            if (this.editedIndex == -1) {
                var exists = this.luItems.find((x: any) => x.programName == this.editedItem.programName || x.programId == this.editedItem.programId);
                if (exists != null) {
                    this.errorMessage = "This Program Name/Id already exists.";
                    return;
                }
            }
            else {
                var exists = this.luItems.find((x: any) => x.id != this.editedItem.id && (x.programName == this.editedItem.programName || x.programId == this.editedItem.programId));
                if (exists != null) {
                    this.errorMessage = "This Program Name/Id already exists.";
                    return;
                }
            }


            this.editedItem.isManual = true; //only allowing manual program add/edit

            this.$store.dispatch("changeLoaderStatus", true);
            lookupsService.editCertProgram(this.editedItem)
                .then((res) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)
                        }
                        else {
                            this.editedItem.id = res.id;
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem)

                            }
                        }
                        this.close();
                    }
                    else {
                        this.saveErrorMessage = res.messages.join(', ')
                        this.reloadItems(); //in case something was changed after that pull
                    }
                })
                .catch(this.$handleError)
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));
        },

    },
    computed: {
        formTitle() {
            return this.$data.editedIndex === -1 ? "New Item" : "Edit Item";
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },

});
</script>
